module.exports = __webpack_public_path__ + "media/images/meta/stretchlab/apple-touch-icon-ebf4216528ab101219a3deb8787d4393.png";